import { render } from "./exportComponent.vue?vue&type=template&id=237785ca&scoped=true"
import script from "./exportComponent.vue?vue&type=script&lang=js"
export * from "./exportComponent.vue?vue&type=script&lang=js"

import "./exportComponent.vue?vue&type=style&index=0&id=237785ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237785ca"]])

export default __exports__